import { useSafeDealerItemContext } from "@mobility-item-page/dealer/client";
import { ElementType, Intent, ObjectPosition, TargetType } from "@mobility-item-page/utilities/client";
import { useAdViewAd } from "src/context/AdViewProviderContext.tsx";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import usePulse from "src/utils/pulse-tracking/usePulse.ts";

export const CityLink = () => {
  const { location } = useAdViewAd();
  const { googleMapsEmbed } = useAppConfig();
  const { trackClick } = usePulse();

  // Try to get organisation location as fallback
  const dealerItemContext = useSafeDealerItemContext();

  // Get city and country from ad location (primary source)
  let city = location?.postalName;
  let country = location?.countryName;

  // Fallback to organisation location if ad location is missing
  if (!city && !country && dealerItemContext?.location) {
    city = dealerItemContext.location.city;
    country = dealerItemContext.location.country;
  }

  // Create the display text (only city or country, no street or postal code)
  const cityOrCountry = city || country || "";

  if (!cityOrCountry) {
    return null;
  }
  const streetAddress = location?.streetAddress;
  const shortAddress = `${location?.postalCode} ${cityOrCountry}`;
  const fullAddress = streetAddress ? `${streetAddress}, ${shortAddress}` : shortAddress;

  // Create the link href
  const mapHref = googleMapsEmbed
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`
    : location?.position?.links?.finnvector?.uri;

  return (
    <>
      <div className="s-bg-inverted	h-24 mx-4 shrink-0" style={{ width: "1px", opacity: 0.3 }} />
      {!mapHref ? (
        <span className="text-ellipsis overflow-hidden ml-12 min-w-0">{cityOrCountry}</span>
      ) : (
        <a
          href={mapHref}
          target={googleMapsEmbed ? "_blank" : "_self"}
          rel={googleMapsEmbed ? "noopener nofollow" : undefined}
          className="min-w-0 text-ellipsis overflow-hidden ml-12"
          onClick={() =>
            trackClick({
              name: "Go to map",
              objectId: "CE_ev54",
              elementType: ElementType.Link,
              intent: Intent.Open,
              position: ObjectPosition.BelowGallery,
              target: {
                id: mapHref,
                type: googleMapsEmbed ? TargetType.ExternalContent : TargetType.Page,
              },
            })
          }
        >
          {cityOrCountry}
        </a>
      )}
    </>
  );
};
